module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Enhanced-Focus.c360d66a.jpg";